import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getFundUpdates } from 'src/app/home/adapters'
import { mapFundUpdateItem } from 'src/app/home/pages/fund-updates/domain/use-cases/map-fund-update-item'
import type { IDocumentUpdateEntity } from 'src/app/home/pages/fund-updates/types'
import { fundUpdatesKeys } from 'src/app/home/queries/keys'

export interface IFundUpdatesQueryResult {
  items: IDocumentUpdateEntity[]
  total: number
  page: number
  pageSize: number
}

export interface IUseFundUpdatesQueryParams {
  page: number
  pageSize: number
  category: string
  enabled: boolean
  silentErrorToast?: boolean
}

export const useFundUpdatesQuery = (
  params: IUseFundUpdatesQueryParams,
): UseQueryResult<IFundUpdatesQueryResult, Error> => {
  return useQuery({
    queryKey: fundUpdatesKeys.list({
      page: params.page,
      pageSize: params.pageSize,
      category: params.category,
    }),
    ...(params.silentErrorToast ? { meta: { silent: true } } : {}),
    queryFn: async (): Promise<IFundUpdatesQueryResult> => {
      const response = await getFundUpdates({
        page: params.page,
        pageSize: params.pageSize,
        category: params.category || undefined,
      })
      return {
        items: response.data.map(mapFundUpdateItem),
        total: response.total,
        page: response.page,
        pageSize: response.page_size,
      }
    },
    enabled: params.enabled,
  })
}
